<template>
    <div>
        <!-- VIEW -->
        <v-container>
            <v-row class="ma-0">
                <v-col cols="7" class="text-right">
                    <span class="headline text-center">Paket Lelang Tahun Anggaran </span>
                </v-col>
                <v-col cols="2">
                    <v-select
                            :items="itemsTahunAnggaran"
                            label="Tahun Anggaran"
                            v-model="tahunAnggaranSel"
                            single-line
                            dense
                            class="headline"
                            @change="tahunAnggaranSelChange"
                    ></v-select>
                </v-col>
            </v-row>
            <v-row class="mx-2">
                <v-col cols="2">
                </v-col>
                <v-col cols="10">
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                            clearable
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="mx-2">
                <v-col cols="10">
                </v-col>
                <v-col cols="2">
                    <v-btn color="cyan" dark @click="refreshPage()">Refresh</v-btn>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="12">
                    <v-data-table
                        class="elevation-1"
                        :headers="table.headers"
                        :items="table.items"
                        :items-per-page="10"
                        :single-select="true"
                        :search="search"
                        item-key="id"
                        no-data-text="Belum ada data !"
                        height="400"
                        fixed-header>

                        <template v-slot:item.totalPagu="{item}">
                            <div class="text-right">
                                {{ getNumberSep(item.totalPagu) }}
                            </div>
                        </template>

                        <template v-slot:item.volumePekerjaan="{item}">
                            {{ item.volumePekerjaan }} Paket
                        </template>

                        <template v-slot:item.jenisPengadaan="{item}">
                            {{ getJenisPengadaan(item.jenisPengadaan) }}
                        </template>

                        <template v-slot:item.metodePemilihan="{item}">
                            {{ getMetodePemilihan(item.metodePemilihan) }}
                        </template>

                        <template v-slot:item.satuanKerja="{item}">
                            {{ getDivisi(item.satuanKerja) }}
                        </template>

                        <template v-slot:item.statusPelaksanaan="{item}">
                            <v-chip :color="getColorStatus(item.statusPelaksanaan)">
                                {{ getStatusPelaksanaan(item.statusPelaksanaan) }}
                            </v-chip>
                        </template>

                        <template v-slot:item.actions="{item}">
                            <v-btn color="blue" small icon @click="openForm(item, true)"> <v-icon small class="mr-2">mdi-file-find</v-icon> </v-btn>
                            <v-btn v-if="item.statusPelaksanaan !== 'S'" color="blue" small icon @click="openFormRevisiJadwal(item)"> <v-icon small class="mr-2">mdi-calendar-edit</v-icon> </v-btn>
                            <v-btn color="blue" small icon @click="openFormUploadFileJadwal(item)"> <v-icon small class="mr-2">mdi-upload</v-icon> </v-btn>
                            <v-btn color="cyan" small dark  @click="openForm(item, false)" v-if="item.statusPelaksanaan === 'N' && item.status === 'AM'">Publish</v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="form.isShowing" persistent max-width="100%">
            <v-container>
                <v-card>
                    <v-card-text>
                        <!-- <ProsesLelangUser :paket="form.paket" :jadwal="listJadwal"/> -->
                        <ProsesLelangUser />
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="cyan" dark @click="closeForm">Tutup</v-btn>
                        <v-btn color="green" dark @click="publishPaket" v-if="form.paket.statusPelaksanaan === 'N'">Publish</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="orange" dark @click="showConfirmationGagal = true" v-if="form.paket.statusPelaksanaan === 'A'">Gagal lelang / Tidak ada pemenang</v-btn>
                        <v-btn color="red" dark @click="showConfirmationBatal = true" v-if="form.paket.statusPelaksanaan === 'A'">Batal lelang</v-btn>
                    </v-card-actions>
                </v-card>
            </v-container>
        </v-dialog>

        <!-- UPDATE JADWAL -->
        <v-dialog v-model="formRevisiJadwal.isShowing" persistent max-width="90%">
            <UpdateJadwal v-if="formRevisiJadwal.paket != null" 
                :paketId="formRevisiJadwal.paket.id" 
                :paketKode="formRevisiJadwal.paket.kode" 
                :paketNama="formRevisiJadwal.paket.nama" 
                @closed="closeFormRevisiJadwal()"
            />
        </v-dialog>

        <!-- UPLOAD FILE JADWAL -->
        <v-dialog v-model="formUploadFileJadwal.isShowing" persistent max-width="80%">
            <UploadFileJadwal v-if="formUploadFileJadwal.paket != null"
                :paketId="formUploadFileJadwal.paket.id"
                :paketKode="formUploadFileJadwal.paket.kode" 
                :paketNama="formUploadFileJadwal.paket.nama" 
                @closed="closeFormUploadFileJadwal()"
            />
        </v-dialog>
        
        <v-dialog v-model="showConfirmationGagal" max-width="500px" persistent>  
            <v-card dark>
                <v-card-title>Anda yakin ingin menggagalkan proses tender?</v-card-title>
                <v-divider />
                <v-card-actions>
                    <v-btn color="orange" dark @click="submitTenderGagal()">Gagal</v-btn>
                    <v-btn color="cyan" dark @click="showConfirmationGagal = false">Tutup</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="showConfirmationBatal" max-width="500px" persistent>  
            <v-card dark>
                <v-card-title>Anda yakin ingin membatalkan proses tender?</v-card-title>
                <v-divider />
                <v-card-actions>
                    <v-btn color="red" dark @click="submitTenderBatal()">Batal</v-btn>
                    <v-btn color="cyan" dark @click="showConfirmationBatal = false">Tutup</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Notification -->
        <v-snackbar
                v-model="notification.show"
                :color="notification.color"
                :top="true"
                :right="true"
                :timeout=3000
        >
            {{notification.text}}
        </v-snackbar>

    </div>
</template>

<script>
    const axios = require('axios').default;

    import { rules } from './../../lib/rules'
    import { getValueItem, itemsDivisi, tahunAnggaran, } from './../../lib/viewLib'
    import {
        itemsMetodePemilihan, itemsJenisPengadaan, itemsKualifikasi, itemsMetodeEvaluasi, itemsJenisKontrak, listJadwalPengadaan,
        getJadwalLelang,
    } from './../../lib/viewTenderLib'
    import { format } from 'date-fns'
    const apiUrl = process.env.VUE_APP_ROOT_API

    import ProsesLelangUser from './../../components/lelang/ProsesLelangUser'
    import UpdateJadwal from "./../../components/lelang/UserUpdateJadwal"
    import UploadFileJadwal from "./../rup/RupFileJadwal"


    export default {
        components: {
            ProsesLelangUser,
            UpdateJadwal,
            UploadFileJadwal
        },

        data() {
            return {
                listJadwal: [],

                // Table
                table:
                    {
                        headers:
                            [
                                { text: "Kode", value: "kode" },
                                { text: "Nama Paket", value: "nama" },
                                { text: "Volume", value: "volumePekerjaan" },
                                { text: "Pengadaan", value: "jenisPengadaan" },
                                { text: "Pemilihan", value: "metodePemilihan" },
                                { text: "HPS", value: "totalPagu", align: 'end'},
                                { text: "Pengguna", value: "satuanKerja" },
                                { text: "Status", value: "statusPelaksanaan" },
                                { text: "Actions", value: "actions", sortable: false }
                            ],
                        items: []
                    },

                itemsTahunAnggaran: tahunAnggaran,
                tahunAnggaranSel: 2021,
                rules: { required: rules.required },
                search: '',
                divisi: this.$store.getters.userInfo.divisi,
                itemsDivisi: itemsDivisi,

                listPPK: [],
                listKegiatan: [],
                listProgram: [],
                listLokasiProyek: [],
                listCOA: [],
                listSumberDana: [],
                listKBLI: [],
                listMetodePemilihan: [],
                listKualifikasi: itemsKualifikasi,
                listMetodeEvaluasi: [],
                listJenisKontrak: [],
                listJenisPengadaan: [],
                listVendor: [],

                limitLangsung: 0,
                kodeRUP: "",
                totalPekerjaan: 0,
                paguKegiatan: 0,
                paguTerpakai: 0,
                paguSisa: 0,
                kegiatanSelect: null,
                // Form
                form:
                    {
                        paket:
                            {
                                kode: "",
                                kegiatanId: 0,
                                ppk: "",
                                id: null,
                                nama: "",
                                tahunAnggaran: 0,
                                isPDN: false,
                                isUsahaKecil: false,
                                satuanKerja: "",
                                volumePekerjaan: 1,
                                listLokasiKerja: [],
                                listPendanaan: [],

                                totalPagu: 0,
                                totalPaguLama: 0,
                                kbli: "",
                                bobotTeknis: 0,
                                bobotHarga: 0,
                                passingGrade: 0,
                                deskripsi: '',

                                jenisPengadaan: "",
                                metodePemilihan: "",
                                metodeEvaluasi: "",
                                kualifikasi: "",
                                jenisKontrak: "",

                                pelaksanaanKontrakAwal: null,
                                pelaksanaanKontrakAkhir: null,
                                pelaksanaanPemilihanPenyediaAwal: null,
                                pelaksanaanPemilihanPenyediaAkhir: null,

                                fileLain: null,
                                fileLampiran: null,
                                fileKAK: null,
                            },
                        programId: 0,
                        // listKegiatanByProgram: [],
                        isShowing: false,
                        isEditing: false,
                        isView: false,
                        isDeleting: false,
                        isValid: false
                    },

                formListLokasiKerja: [{
                    lokasiProyekId: 0,
                    detail: "",
                    nilaiPekerjaan: 0,
                    uraianPekerjaan: "",
                    spesifikasiPekerjaan: "",
                    lampiran: "",
                    paketPenyediaId: 0,
                }],
                formListPendanaan: [{
                    sumberDana: "",
                    asalDana: "",
                    mak: 0,
                    pagu: 0
                }],
                formListJadwalPengadaan: [],

                // Notification
                notification:
                    {
                        show: false,
                        color: "",
                        text: ""
                    },

                menuBerlaku: false,
                readMetode: false,
                allListMetodePemilihan: itemsMetodePemilihan,
                allMetodeEvaluasi: itemsMetodeEvaluasi,
                allJenisKontrak: itemsJenisKontrak,
                allJadwalPengadaan: listJadwalPengadaan,
                isKualifikasi: false,
                timePickerProps: {
                    format: '24hr'
                },

                formRevisiJadwal: {
                    paket: null,
                    isShowing: false,
                },

                formUploadFileJadwal: {
                    paket: null,
                    isShowing: false
                },
                
                showConfirmationGagal: false,
                showConfirmationBatal: false,

            }
        }, // data:

        async created() {
            this.tahunAnggaranSel = this.$store.getters.tahunAnggaran
            await this.getData()
            this.listJenisPengadaan = itemsJenisPengadaan
            await this.getListVendor()
        },

        computed: {

        },

        methods: {
            submitTenderGagal() {
                axios.put(`${apiUrl}/api/rup/lelang/gagal/${this.form.paket.id}`)
                .then( () => {
                    this.notification = {
                        show: true,
                        color: "success",
                        text: "Proses tender telah digagalkan / tidak ditemukan pemenang"
                    };

                    this.showConfirmationGagal = false;

                    setTimeout(() => {
                        this.closeForm();
                    }, 3000);
                })
                .catch( (error) => {
                    console.error(error);
                    this.notification = {
                        show: true,
                        color: "error",
                        text: `Gagal update proses penyelesaian tender [${error.message}]`
                    }
                });
            },
            submitTenderBatal() {
                axios.put(`${apiUrl}/api/rup/lelang/batal/${this.form.paket.id}`)
                .then( () => {
                    this.notification = {
                        show: true,
                        color: "success",
                        text: "Proses tender telah dibatalkan"
                    };

                    this.showConfirmationBatal = false;

                    setTimeout(() => {
                        this.closeForm();
                    }, 3000);
                })
                .catch( (error) => {
                    console.error(error);
                    this.notification = {
                        show: true,
                        color: "error",
                        text: `Gagal update proses penyelesaian tender [${error.message}]`
                    }
                });
            },
            getData() {
                axios.get(`${apiUrl}/api/rup/paket/status/AM/tahun/${this.tahunAnggaranSel}`)
                    .then( (response) => {
                        this.table.items = response.data;
                        // console.log("LIST PAKET: ", response.data);
                    })
                    .catch( (error) => { console.error(error); });
            },
            getDateFormattedDatefns: function(date) {
                // console.log(`tgl yg masuk: ${date}`)
                return date ? format(date, "dd MMM yyyy HH:mm") : ''
            },
            tahunAnggaranSelChange() {
                this.getData()
            },
            getJenisPengadaan(val) {
                return val ? getValueItem(this.listJenisPengadaan, val) : ''
            },
            getMetodePemilihan: function(val) {
                return val ? getValueItem(this.allListMetodePemilihan, val) : ''
            },
            getListVendor() {
                axios.get(`${apiUrl}/vendor/kbli`)
                    .then( (response) => {
                        this.listVendor = response.data
                    })
                    .catch( (error) => {
                        console.error(error);
                    });
            },
            publishPaket() {
                axios.post(`${apiUrl}/api/rup/paket/publish`, { paketPenyediaId: this.form.paket.id })
                    .then( (response) => {
                        console.log(response)
                        this.getData()
                        this.notification = {
                            show: true,
                            color: "success",
                            text: "Paket telah dipublish"
                        }
                        this.closeForm()
                    })
                    .catch( (error) => {
                        console.error(error);
                        this.notification = {
                            show: true,
                            color: "error",
                            text: `[${error.message}] Gagal publish paket`
                        };
                    });
            },
            getNumberSep: function(data) {
                return parseInt(data, 10).toLocaleString('de-DE')
            },
            getStatusPelaksanaan: function(data) {
                let caption =''
                switch (data) {
                    case 'A':
                        caption = 'Aktif'
                        break
                    case 'S':
                        caption = 'Selesai'
                        break
                    case 'G':
                        caption = 'Gagal / Tidak ada pemenang'
                        break
                    case 'U':
                        caption = 'Ulang'
                        break
                    case 'P':
                        caption = 'Pending'
                        break
                    case 'B':
                        caption = 'Batal'
                        break
                    default:
                        caption = 'Baru'
                }
                return caption
            },
            /* getStatus: function(data) {
              let caption =''
              switch (data) {
                case 'AM':
                  caption = 'Approve Manajer'
                  break
                case 'AP':
                  caption = 'Approve PPK'
                  break
                case 'AU':
                  caption = 'Approve ULP'
                  break
                case 'AD':
                  caption = 'Approve Direksi'
                  break
                case 'RM':
                  caption = 'Reject Manajer'
                  break
                case 'RP':
                  caption = 'Reject PPK'
                  break
                case 'RU':
                  caption = 'Reject ULP'
                  break
                case 'RD':
                  caption = 'Reject Direksi'
                  break
                default:
                  caption = 'Baru'
              }
              return caption
            }, */
            getColorStatus: function(data) {
                let caption =''
                switch (data) {
                    case 'S':
                        caption = 'success'
                        break
                    case 'P':
                        caption = 'warning'
                        break
                    case 'G':
                        caption = 'warning'
                        break
                    case 'B':
                    case 'U':
                        caption = 'error'
                        break
                    default:
                        caption = 'info'
                }
                return caption
            },
            getDivisi: function(data) {
                return data ? getValueItem(itemsDivisi, data) : ''
            },
            /* getCurrentDateTime() {
              axios.get(`${apiUrl}/api/rup/paket/server/dttm`)
              .then( (response) => {
                console.log("Jam Server: ", response.data);
                return response.data;
              })
              .catch( (error) => { console.error(error); });
            },    */
            resetForm() {
                this.listJadwal = []
                this.kodeRUP = "";
                this.totalPekerjaan = 0;
                this.paguKegiatan = 0;
                this.paguTerpakai = 0;
                this.paguSisa = 0;
                this.kegiatanSelect = null;

                this.form.paket = {
                    kode: "",
                    kegiatanId: 0,
                    ppk: "",
                    id: null,
                    nama: "",
                    tahunAnggaran: this.tahunAnggaranSel,
                    isPDN: false,
                    isUsahaKecil: false,
                    satuanKerja: "",
                    volumePekerjaan: 1,
                    listLokasiKerja: [],
                    listPendanaan: [],
                    listJadwal: [],
                    totalPagu: 0,
                    totalPaguLama: 0,
                    kbli: "",
                    bobotTeknis: 0,
                    bobotHarga: 0,
                    passingGrade: 0,
                    noArsip: "",
                    deskripsi: '',
                    jenisPengadaan: "",
                    metodePemilihan: "",
                    metodeEvaluasi: "",
                    kualifikasi: "",
                    jenisKontrak: "",
                    pelaksanaanKontrakAwal: null,
                    pelaksanaanKontrakAkhir: null,
                    pelaksanaanPemilihanPenyediaAwal: null,
                    pelaksanaanPemilihanPenyediaAkhir: null,
                    fileLain: null,
                    fileLampiran: null,
                    fileKAK: null,
                };
                this.formListLokasiKerja = [{
                    lokasiProyekId: 0,
                    detail: "",
                    nilaiPekerjaan: 0,
                    uraianPekerjaan: "",
                    spesifikasiPekerjaan: "",
                    lampiran: "",
                    paketPenyediaId: 0,
                }],
                    this.formListPendanaan = [{
                        sumberDana: "",
                        asalDana: "",
                        mak: "",
                        pagu: 0
                    }],
                    this.formListJadwalPengadaan = [],

                    this.form.programId = "";
                // this.form.listKegiatanByProgram = [];
                this.listMetodePemilihan = [];

                console.log("RESET FORM");
                console.log(this.form.paket.pelaksanaanPemilihanPenyediaAkhir);
            },
            async openForm(paket, view) {
                if (paket)
                {
                    this.form.paket = Object.assign({}, paket);
                    this.listJadwal = await getJadwalLelang(paket.id)
                    console.log('this.listJadwal',this.listJadwal);
                    // assign store
                    this.$store.dispatch('lelang/assignPaket', paket)
                    this.$store.dispatch('lelang/assignJadwal', this.listJadwal)

                    this.form.isEditing = true;
                    this.form.isShowing = true;
                    this.form.isView = view;
                    console.log(this.form.isView)
                }
                else
                {
                    this.resetForm();
                    this.form.isShowing = true;
                }
            },
            closeForm() {
                this.form.isShowing = false;
                this.form.isEditing = false;
                this.form.isDeleting = false;
                this.form.isView = false;
                //refresh page
                this.$router.push({ name: 'TemporaryPage', params: { link: '/ppk/tender'} }); 
            },

            refreshPage() {
                this.$router.push({ name: 'TemporaryPage', params: { link: '/ppk/tender'} }); 
            },

            openFormRevisiJadwal(paket) {
                this.formRevisiJadwal = {
                    paket: paket,
                    isShowing: true
                };
            },

            closeFormRevisiJadwal() {
                this.formRevisiJadwal = {
                    paket: null,
                    isShowing: false
                };
            },

            openFormUploadFileJadwal(paket) {
                this.formUploadFileJadwal = {
                    paket: paket,
                    isShowing: true
                }
            },

            closeFormUploadFileJadwal() {
                this.formUploadFileJadwal = {
                    paket: null,
                    isShowing: false
                }
            },
            

        } // methods:
    }

</script>

<style scoped>

    .container{
        max-width: 100vw;
        padding:0px;
    }

</style>